import Route from '@ember/routing/route';

export default class NzReportRoute extends Route {}
